//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import adobeAnalyticsIcon from '@images/adobe-analytics.png';
import googleAnalyticsIcon from '@images/ga.png';
import { getGoogleAnalyticsConnectionService } from '@react-bridge/wrappers/ng-service-provider';
import { recordEvent } from '@tracker/tracker';
import { TRACKING_ACTION, TRACKING_CATEGORY } from '@tracker/trackerModel';
import { OnboardingStepCard } from '@welcome-page/components/onboarding/steps/OnboardingStepCard';
import { OnboardingState } from '@welcome-page/components/onboarding/steps/OnboardingStepCardGrid';
import { ONBOARDING_STEP_ICON_SIZE } from '@welcome-page/constants/OnboardingConstants';

export const OnboardingAnalyticsCard = ({
  isError,
  status,
}: OnboardingState) => {
  const onClickConnect = () => {
    recordEvent(
      TRACKING_CATEGORY.SHOPIFY_ONBOARDING,
      TRACKING_ACTION.CONNECT_ACCOUNT,
      'GoogleAnalytics',
    );
    void getGoogleAnalyticsConnectionService().connect();
  };

  return (
    <OnboardingStepCard
      description='Connect Google Analytics or Adobe Analytics to view commerce metrics.'
      icons={[
        <img
          key='google-analytics-logo'
          alt=''
          height={ONBOARDING_STEP_ICON_SIZE}
          src={googleAnalyticsIcon}
          width={ONBOARDING_STEP_ICON_SIZE}
        />,
        <img
          key='adobe-analytics-logo'
          alt=''
          height={ONBOARDING_STEP_ICON_SIZE}
          src={adobeAnalyticsIcon}
          width={ONBOARDING_STEP_ICON_SIZE}
        />,
      ]}
      onClickConnect={onClickConnect}
      showAlarmTooltip={isError}
      status={status}
      title='Analytics'
    />
  );
};
